import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const Routes = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./routes')).ReportingRoutes })
  )
)
